import { render, staticRenderFns } from "./PlansEnterpriseFooter.vue?vue&type=template&id=f06a647c&scoped=true&"
var script = {}
import style0 from "./PlansEnterpriseFooter.vue?vue&type=style&index=0&id=f06a647c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f06a647c",
  null
  
)

export default component.exports